<template>
  <Loading v-if="componentLoading" :style="loadingStyle" />
  <div v-else class="pft-function-for" :style="style">
    <template v-for="(item, index) in list" :key="item.key">
      <component
        :is="item.componentClass"
        :ref="el => componentRefs(item.key, el)"
        v-bind="getProps(index)"
        @mouseenter="mouseenter(index)"
        @mouseleave="mouseleave"
        :style="item.style"
      />
    </template>
  </div>
</template>
<script lang="ts" setup>
// 轮播组件，通过props.data来传递数据，通过props.getComponent来获取组件的class，组件要求要有show和hide两个方法
import { ref, onMounted, CSSProperties, nextTick, onUnmounted, computed, watch } from "vue"
import { defaultsDeep, cloneDeep } from "lodash-es"
import Loading from "@p-v/packages/Loading.vue"
const componentLoading = ref<boolean>(true)
// TODO: 后续需要更改嵌套组件的声明方式，不要通过data来传递，建议是通过props来传递。暂时不考虑多类型组件的问题
interface ComponentProps {
  style?: CSSProperties
  getComponent: (component: string, kind?: string) => Promise<any>
  duration?: number
  data: ComponentItem[]
  component: string
  resetOnHover?: boolean
}

interface ComponentItem {
  key: string
  component?: string
  props: any
  style: CSSProperties
  sort: number
  data?: any
}

const props = withDefaults(defineProps<ComponentProps>(), {
  style: () => ({}),
  getComponent: () => Promise.resolve(null),
  duration: 5000,
  data: () => [],
  resetOnHover: false,
  component: "",
})

const list = ref<(ComponentItem & { componentClass: any; ref?: any })[]>([])
const currentIndex = ref<number>(0)

const loadingStyle = computed(() => {
  return defaultsDeep(props.style, {})
})

const getProps = (index: number) => {
  const itemProps = list.value[index].props
  if (list.value[index].data) {
    itemProps.data = list.value[index].data
    itemProps.storeData = list.value[index].data
  }
  const props = {
    ...itemProps,
  }
  return props
}

const componentRefs = (key: string, el: any) => {
  const checkComponent = list.value.find(item => item.key === key)
  if (checkComponent) {
    checkComponent.ref = el
  }
}
const loading = () => {
  componentLoading.value = true
}
const setData = async (data: ComponentItem[]) => {
  let newList: any[] = cloneDeep(list.value)
  let commonComponent = null
  if (props.component) {
    commonComponent = await props.getComponent(props.component)
  }
  for (let i = 0; i < data.length; i++) {
    // 查看key是否存在
    const checkItem = newList.find(item => item.key === data[i].key)
    let curComponent = commonComponent
    if (checkItem) {
      // 如果存在，则更新
      if (checkItem.component && checkItem.component !== props.component) {
        curComponent = await props.getComponent(checkItem.component)
      }
      checkItem.componentClass = curComponent
      checkItem.props = data[i].props
      checkItem.style = data[i].style
      continue
    } else {
      if (data[i].component) {
        curComponent = await props.getComponent(data[i].component!)
        newList.push({ ...data[i], componentClass: curComponent })
      }
    }
  }
  // 排序
  newList.sort((a, b) => {
    return a.sort - b.sort
  })
  list.value = newList
  nextTick(() => {
    list.value.forEach(item => {
      if (item.ref) {
        if (item.ref && item.ref.setData) {
          item.ref.setData(item.data)
        }
      }
    })
  })
  componentLoading.value = false
}
const timmer = ref<any>()
const refreshCom = () => {
  list.value.forEach((item, index) => {
    if (currentIndex.value === index) {
      item.ref?.show && item.ref?.show()
    } else {
      item.ref?.hide && item.ref?.hide()
    }
  })
}
const start = () => {
  timmer.value = setInterval(() => {
    currentIndex.value++
    if (currentIndex.value >= list.value.length) {
      currentIndex.value = 0
    }
    refreshCom()
  }, props.duration)
}
let indexBeforeHover = 0
const mouseenter = (index: number) => {
  if (props.resetOnHover) {
    indexBeforeHover = currentIndex.value
  }
  currentIndex.value = index
  refreshCom()
  clearInterval(timmer.value)
}
const mouseleave = () => {
  if (props.resetOnHover) {
    currentIndex.value = indexBeforeHover
  }
  start()
}

const initWatch = watch(
  () => list.value,
  (val: any[]) => {
    // 如果所有组件都有ref，则开始轮播
    const hasRef =
      val.length > 0 &&
      val.every(item => {
        return !!item.ref
      })
    if (hasRef) {
      initWatch()
      start()
      setTimeout(() => {
        refreshCom()
      }, 500)
    }
  },
  {
    immediate: true,
    deep: true,
  },
)

defineExpose({ setData, loading })

onMounted(async () => {
  await setData(props.data)
})
onUnmounted(() => {
  clearInterval(timmer.value)
})
</script>

<style lang="scss">
.pft-function-for {
}
</style>
